import ouiStyle from '@goldwasserexchange/oui-style';

export const getTriggerButtonStyle = (props: {
  done: boolean,
  hasError: boolean,
  disabled?: boolean,
  baseBackgroundColor: ouiStyle.Constants.Colors,
  baseBorderColor: ouiStyle.Constants.Colors,
  baseHoverBackgroundColor: ouiStyle.Constants.Colors,
}): ouiStyle.InStyle & { disabled: boolean, hoverBackgroundColor: ouiStyle.Constants.Colors } => {
  const {
    done,
    hasError,
    disabled = false,
    baseBackgroundColor,
    baseBorderColor,
    baseHoverBackgroundColor,
  } = props;
  if (hasError) {
    return {
      disabled: true,
      backgroundColor: ouiStyle.Constants.Colors.danger,
      borderColor: ouiStyle.Constants.Colors.danger,
      hoverBackgroundColor: ouiStyle.Constants.Colors.danger,
    };
  }
  if (done) {
    return {
      disabled: true,
      backgroundColor: ouiStyle.Constants.Colors.buttonBorderGrey,
      borderColor: ouiStyle.Constants.Colors.buttonBorderGrey,
      hoverBackgroundColor: ouiStyle.Constants.Colors.buttonBorderGrey,
    };
  }
  return {
    disabled,
    backgroundColor: baseBackgroundColor,
    borderColor: baseBorderColor,
    hoverBackgroundColor: baseHoverBackgroundColor,
  };
};
